import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "report" }
const _hoisted_2 = { class: "jumbotron" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", { class: "display-4" }, "Error!", -1)
const _hoisted_5 = { class: "lead" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h1", { class: "display-4" }, "Thank you!", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "lead" }, " Thank you for activating ACT on The Depositary. We are now ready to send/receive data between the two systems. ", -1)
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]

import {computed, ref} from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'CustomerLinkbackResponse',
  setup(__props) {

const em = ref('');
const errormessage = computed({
  get: () => em.value,
  set: (val: string) => em.value = val,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (errormessage.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("p", _hoisted_5, _toDisplayString(errormessage.value), 1)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_9))
    ])
  ]))
}
}

})